<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>تخلیه حساب </span> <span v-if="selectedAccount" class="text-bold"> {{
          selectedAccount.accountNumber
        }} </span>
        <template v-slot:action>
          <q-chip color="green" text-color="white" icon-right="attach_money">
            <span v-if="!$q.screen.lt.md">موجودی حساب</span> <span
              class="q-ml-xs text-bold">{{ accountBalance.toLocaleString() }}</span>
            <q-tooltip v-if="!$q.screen.lt.md">
              موجودی حساب
            </q-tooltip>
          </q-chip>
          <q-btn icon="close" round flat v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-select v-model="supplySelectedAccount"
                filled
                dir="ltr"
                label="حساب تامین کننده"
                :options="supplyAccounts"
                option-label="label"
                option-value="accountNumber"
                map-options
                emit-value
      />
    </q-card-section>
    <q-card-section v-if="supplySelectedAccount">
      <q-list bordered>
        <q-item>
          <q-item-section avatar>
            <q-icon name="done_all" color="green"/>
          </q-item-section>

          <q-item-section>ارسال کلیه درخواست</q-item-section>
          <q-item-section side>
            <q-btn icon="request_page" flat round @click="sendAll" v-if="!inProcess">
              <q-tooltip>
                ارسال کلیه درخواست ها
              </q-tooltip>
            </q-btn>
          </q-item-section>
        </q-item>
        <q-item v-for="(item, index) in workflowItems" :key="index">
          <q-item-section avatar>
            <q-icon :color="item.done?'green':'red'" :name="item.done?'check_circle':'cancel'"/>
          </q-item-section>

          <q-item-section>{{ item.caption }}</q-item-section>
          <q-item-section side>
            <q-btn icon="request_page" flat round @click="sendRequest(item)" v-if="!inProcess">
              <q-tooltip>
                ارسال درخواست
              </q-tooltip>
            </q-btn>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "EmptyAccount",
  props: {
    selectedAccount: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    accountBalance: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {
      supplyAccounts: [
        {accountNumber: 'IR190550190370106093443001', label: 'IR190550190370106093443001'},
        {accountNumber: 'IR920560970180004431899001', label: 'IR920560970180004431899001'},
        {accountNumber: 'IR460560970188804431899001', label: 'IR460560970188804431899001'},
        {accountNumber: 'IR620620000000101480222005', label: 'IR620620000000101480222005'}
      ],
      supplySelectedAccount: undefined,
      inProcess: false,
      distinationInfo: {
        shaba: undefined,
        shabaVerify: false,
        cardNumber: undefined,
        money: 0,
        name: undefined,
        cardVerify: undefined
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      workflowItems: [
        {
          id: -1,
          caption: 'انتقال وجه به حقوق',
          done: false,
          distinationIban: 'IR120560970170004431899001',
          destinationFirstname: 'مریم',
          destinationLastname: 'خادم',
          description: 'صندوق حقوق',
          cost: 0,
          accountNumber: '0101480222005'
        },
        {
          id: 0,
          caption: 'انتقال وجه به صندوق پس انداز',
          done: false,
          distinationIban: 'IR610120020000009636705501',
          destinationFirstname: 'فاطمه',
          destinationLastname: 'نام خواه',
          description: 'صندوق پس انداز',
          cost: 0,
          accountNumber: '0101480222005'
        },
        {
          id: 1,
          caption: 'انتقال وجه به کیف پول بارنامه',
          done: false,
          distinationIban: 'IR610620000000303647823007',
          destinationFirstname: 'فاطمه',
          destinationLastname: 'نام خواه',
          description: 'کیف پول بارنامه',
          cost: 0,
          accountNumber: '0101480222005'
        },
        {
          id: 2,
          caption: 'انتقال وجه به حساب تامین کننده',
          done: false,
          distinationIban: this.supplySelectedAccount,
          destinationFirstname: 'فاطمه',
          destinationLastname: 'نام خواه',
          description: 'حساب تامین کننده',
          cost: 0,
          accountNumber: '0101480222005'
        },
        {
          id: 3,
          caption: 'به روز رسانی کیف پول بارنامه',
          done: false,
          walletId: 'e4d2df4c-9f70-4ed9-91ed-7f0757a13e7f',
          accountNumber: '0303647823007'
        },
        {
          id: 4,
          caption: 'به روز رسانی کیف پول اصلی',
          done: false,
          walletId: '2984780d-fe70-48ce-b3f0-f80d220d09e3',
          accountNumber: '0303647823007'
        },
      ],
    }
  },
  methods: {
    ...mapActions({
      getCardInfo: 'Finnotech/getCardInfo',
      getIbanInfo: 'Finnotech/getIbanInfo',
      mainAccountTransferTo: 'Finnotech/mainAccountTransferTo',
      updateWalletInfo: 'Finnotech/updateWalletMoney',
      changeWallet: 'Finnotech/updateWalletMoney',
      getBalance: 'Finnotech/getBalanceByAccountNumber',
    }),
    sendAll() {
      const request0 = this.workflowItems.filter(item => item.id === -1)[0]
      const request1 = this.workflowItems.filter(item => item.id === 0)[0]
      const request2 = this.workflowItems.filter(item => item.id === 1)[0]
      const request3 = this.workflowItems.filter(item => item.id === 2)[0]
      const request4 = this.workflowItems.filter(item => item.id === 3)[0]

      this.sendRequest(request0).then(() => {
        this.sendRequest(request1).then(() => {
          this.sendRequest(request2).then(() => {
            this.sendRequest(request3).then(() => {
              this.sendRequest(request4)
            })
          })
        })
      })
    },
    async sendRequest(item) {
      if (item.id === 0 || item.id === 1 || item.id === 2 || item.id === -1) {
        let localAmount = 0
        if (item.id === -1) {
          localAmount = this.percentage(2, this.accountBalance)
        } else if (item.id === 0) {
          localAmount = this.percentage(1, this.accountBalance)
        } else if (item.id === 1) {
          localAmount = this.percentage(40, this.percentage(10, this.accountBalance))
        } else if (item.id === 2) {
          this.workflowItems.filter(rec => rec.id === 2)[0].distinationIban = this.supplySelectedAccount
          localAmount = this.accountBalance - 200000
        }
        await this.mainAccountTransferTo(
            {
              cost: localAmount,
              description: item.description,
              destinationFirstname: item.destinationFirstname,
              destinationLastname: item.destinationLastname,
              distinationIban: item.distinationIban
            }).then(async (res) => {
              if (res.status === "DONE") {
                item.done = true
                this.$emit('decrease-account-balance', localAmount)
                if (item.id === 1) {
                  const account = this.workflowItems.filter(rec => rec.id === 3)[0].accountNumber
                  await this.getBalance(account).then((res) => {
                    this.changeWallet({
                      walletId: 'e4d2df4c-9f70-4ed9-91ed-7f0757a13e7f',
                      effectiveBalance: res.effectiveBalance
                    }).then(() => {
                      this.workflowItems.filter(rec => rec.id === 3)[0].done = true
                    })
                  })
                }
              }
            }
        )
      } else if (item.id === 3) {
        const account = this.workflowItems.filter(rec => rec.id === 3)[0].accountNumber
        await this.getBalance(account).then((res) => {
          this.changeWallet({
            walletId: 'e4d2df4c-9f70-4ed9-91ed-7f0757a13e7f',
            effectiveBalance: res.effectiveBalance
          }).then(() => {
            this.workflowItems.filter(rec => rec.id === 3)[0].done = true
          })
        })
      }
    },
    percentage(percent, total) {
      return ((percent / 100) * total).toFixed(0)
    },
    getAccountInfo(shaba) {
      if (shaba) {
        if (this.distinationInfo.shaba === undefined) return;
        this.getIbanInfo(`IR${this.distinationInfo.shaba}`).then((res) => {
          this.distinationInfo.name = res.data.depositOwners[0].firstName + ' ' + res.data.depositOwners[0].lastName
          this.distinationInfo.shabaVerify = true
        })
      } else {
        if (this.distinationInfo.cardNumber === undefined) return;
        this.getCardInfo(this.distinationInfo.cardNumber).then((res) => {
          this.distinationInfo.name = res.data.name
        })
      }
    },
  }
}
</script>
<style scoped>

</style>